import Equipped from "./Equipped";
export default Equipped;
